import Modal from "Components/Modal"

import { 
    createContext, 
    useContext, 
    useEffect, 
    useState, 
    useCallback 
} from "react"

import { toast } from 'react-toastify'
import { useNavigate } from "react-router-dom"
//import { isProduction } from "services/utils"
import api from "lib/api_clinica"

const PatientContext  = createContext(null)

const initialStateAgenda = { diaEscolhido: '' }

export const PatientProvider = ({ children }) => {

    const [ open         , setOpen           ] = useState(false)
    const [ patient      , setPatient        ] = useState(null)
    const [ redirect     , setRedirect       ] = useState('')
    const [ loading      , setLoading        ] = useState(false)
    const [ userExists   , setUserExists     ] = useState(false)
    const [ modalFallback, setModalFallback  ] = useState(null)
    const [ agenda       , setAgenda         ] = useState(initialStateAgenda)

    const navigate = useNavigate()
   
    const onChange = event => {
        
        setPatient( prevState => ({
            ...prevState, [event.target.name]: event.target.value,
        }))
    }

    const creactUser = (request) => {

        try {
            
            setLoading(true)
             
            const url = parseInt(patient.idConvenio) === parseInt(process.env.REACT_APP_ID_CONVENIO) ? '/especialidade' : '/convenio'
            
            setPatient( 
                prevState => ({ 
                    ...prevState, ...request, 
                })
            )

            setRedirect(url)
            
        } catch (error) {
            toast.error(error.mensagem)    
        } finally {
            setLoading(false)
        }
    }
   

    const get = useCallback( async (params) => {

        try {

            setLoading(true) 
            
            const response = await api.paciente.byCPF(params)
            
            const { redirect, state, token } = response

            setPatient(state)

            sessionStorage.setItem('agendamento_web_token', token)
            
            if (response?.modal !== undefined) {
                setModalFallback({...response?.modal, redirect, handleConfirm: () => { setOpen(false)  } }) 
                setOpen(true)     
            } else {
                setRedirect(redirect)
            }

        } catch (error) {
            
            toast.error('Não foi possível verificar o CPF informado, problema no servidor.')    
              
        } finally {
            setLoading(false)
        }

    }, [ 
        setPatient, 
        setRedirect, 
        //setUserExists, 
        setModalFallback, 
        setLoading,
        //setOpen
    ])

    const handleSchedulePatient = () => {
        return {...patient, ...agenda}
    }

    const handleClose = () => {
        setOpen(false)
        setRedirect('/central-agendamento')
    }

    const handleConfirmSchedule = async () => {
        try {
            

            // AGENDA
            // dataAgenda      : '',
            // descricaoUnidade: '',
            // diaSemana       : '', 
            // horarioAgenda   : '',
            // idAgCad         : '',
            // idAgenda        : '',
            // idProfissional  : '',
            // nomeProfissional: '', 
            // tipoRestricao   : '',

            const requestPacient = {
                cpfPaciente           : patient.cpfPaciente,
                nomePaciente          : patient.nomePaciente,
                sexoPaciente          : patient.sexoPaciente,
                dataNascimentoPaciente: patient.dataNascimento ?? patient.dataNascimentoPaciente,
                emailPaciente         : patient.emailPaciente,
                dddCelularPaciente    : patient.dddCelularPaciente,
                numeroCelularPaciente : patient.numeroCelularPaciente,
            }

            const responsePacient = await api.paciente.post(requestPacient)
 
            const request = {
                idAgenda             : agenda.id !== undefined ? agenda.id : agenda.idAgenda,
                cpfPaciente          : patient.cpfPaciente,
                idPessoa             : responsePacient.idPessoa,
                nomePessoa           : responsePacient.nomePaciente,
                idPlano              : patient.idPlano,
                observacaoAgendamento: patient.observacaoAgendamento ?? null,
                idEspecialidade      : patient.idEspecialidade,
            }
           

            await api.agenda.post(request)

        } catch (error) {
            console.log(error)
            setRedirect('')
            toast.error('Não foi possível agendar.')
        }
    }

    useEffect( () => {
       
        if (!loading && redirect) {
            navigate(redirect, { replace: true })
        }

        return () => {
            setRedirect('')
        }

    }, [ 
        loading, 
        navigate, 
        setRedirect, 
        redirect 
    ])

    return (
        <PatientContext.Provider value={{ 
            patient, 
            setPatient,

            agenda, 
            setAgenda,
            
            onChange,

            redirect, 
            setRedirect,

            modalFallback,
            setModalFallback,
            open, 
            setOpenFallback: setOpen,

            userExists,
            setUserExists,

            loading, 
            setLoading,

            get,
            creactUser,
            handleConfirmSchedule,
            handleSchedulePatient,
            
            
        }} >
            
            <Modal
                {...modalFallback} 
                open={open} 
                handleClose={handleClose}
                hideImportant
                
            />
            {children}
        </PatientContext.Provider>
    )
} 

export const usePatient = () => useContext(PatientContext)
